/**
 * Shared aria-live announcement regions.
 * Mount ONCE in the app layout root (e.g., App.tsx or providers.tsx).
 *
 * Two regions:
 * - polite: for pending/success announcements (does not interrupt)
 * - assertive: for error/failure announcements (interrupts immediately)
 *
 * Both are visually hidden but read by screen readers.
 */
function AnnouncementRegion() {
  return (
    <>
      <div
        id="ztd-announcement-polite"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      />
      <div
        id="ztd-announcement-assertive"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className="sr-only"
      />
    </>
  );
}

export { AnnouncementRegion };
